<div class="flex flex-col gap-medpace">
    <div>
        <mds-button (clickEvent)="fileDropInput.click()" [label]="'Upload multiple receipts'" [variant]="'outline'" />

        <input
            class="hidden"
            type="file"
            title="Multiple file upload"
            placeholder="Select multiple files to upload them."
            #fileDropInput
            [accept]="accept"
            [multiple]="true"
            (change)="onMultipleFileUpload($event); fileDropInput.value = ''"
        />
    </div>
    <div>
        @if (formGrp().controls.expenses.hasError('required')) {
            <medpace-alert [content]="formGrp().controls.expenses.getError('required')" [appearance]="'danger'" />
        }

        <div class="flex flex-col gap-medpace">
            @for (
                expenseFormGroup of formGrp().controls.expenses.controls;
                track expenseFormGroup;
                let index = $index
            ) {
                <medpace-expense-edit
                    [id]="`paymentInformation_${index}`"
                    [index]="index"
                    [expense]="expenseFormGroup.expense"
                    [formGrp]="expenseFormGroup"
                    (removeEvent)="removeExpense($event)"
                />
            }
        </div>
    </div>
    <div>
        <mds-button
            (clickEvent)="onAddExpenseClick()"
            color="primary"
            [variant]="'tonal'"
            [id]="'addExpense'"
            data-cy="addExpenseButton"
            label="Add expense"
        ></mds-button>
    </div>
    <mds-divider />
    <div class="grid grid-cols-3 gap-medpace">
        <div>
            <h5 class="blackTitle">Date Requested</h5>
            <span>{{ dateRequested$ | async | dateFormat: dateOnly : 'local' | uppercase }}</span>
        </div>
        @let dateSubmitted = dateSubmitted$ | async;
        @if (dateSubmitted) {
            <div>
                <h5 class="blackTitle">Date Submitted</h5>
                <span>{{ dateSubmitted | dateFormat: dateOnly : 'local' }}</span>
            </div>
        }
    </div>

    @let currency = formGrp().controls.totalCurrency.valueChangesReplay | async;
    <div class="grid grid-cols-3 gap-medpace">
        <!-- editing pre-currency conversion request, don't show those fields for new request and those that have already undergone currency conversion -->
        @if (!!request() && isPreCurrencyConversionMigration()) {
            @if (isInProcessOrHigherAndHasElevatedAccess$ | async) {
                <mds-text-field
                    [formCtrl]="formGrp().controls.totalAuthorized"
                    id="totalAuthorizedField"
                    placeholder="Type here..."
                    appearance="outline"
                    [label]="!currency ? 'Total To Be Authorized' : `Total To Be Authorized (${currency.isocode})`"
                    inputType="decimal"
                    [decimalPlaces]="2"
                />

                <mds-dropdown
                    [filterable]="true"
                    [closeOnPageScroll]="false"
                    appearance="outline"
                    label="Currency"
                    placeholder="Select currency"
                    [options]="(currencyOptions$ | async) ?? []"
                    id="total-currency"
                    data-cy="total-currency"
                    [formCtrl]="formGrp().controls.totalCurrency"
                ></mds-dropdown>
            }
        }
    </div>

    @if (isInProcessOrHigherAndHasElevatedAccess$ | async) {
        <div class="grid grid-cols-3 gap-medpace">
            @let patientsCurrencyTotal = totalPatientsCurrencyAmount();
            @if (patientsCurrencyTotal) {
                <medpace-labeled-text
                    [label]="patientsCurrencyTotal.label"
                    [text]="patientsCurrencyTotal.text"
                ></medpace-labeled-text>
            }
            @let usdTotal = totalUsdAmount();
            @if (usdTotal) {
                <medpace-labeled-text [label]="usdTotal.label" [text]="usdTotal.text"></medpace-labeled-text>
            }
        </div>
    }

    @if (elevatedAccess$ | async) {
        <div class="grid grid-cols-3 gap-medpace">
            <mds-datepicker
                [formCtrl]="formGrp().controls.transactionDate"
                id="transactionDate"
                data-cy="requestTransactionDate"
                appearance="outline"
                label="Transaction Date"
                [placeholder]="'Select date'"
            ></mds-datepicker>

            <mds-dropdown
                [closeOnPageScroll]="false"
                [appearance]="'outline'"
                [label]="'Merchant'"
                [placeholder]="'Select merchant'"
                id="paymentMerchantDropdown"
                data-cy="paymentMerchantDropdown"
                [options]="(merchantTypes$ | async) ?? []"
                [formCtrl]="formGrp().controls.merchant"
            ></mds-dropdown>
        </div>
    }

    @if ((isVoided$ | async) === true) {
        <div>
            <medpace-payment-request-deduction-edit [formGrp]="formGrp().controls.deduction" />
        </div>
    }
</div>
